export const marketPlaceEndpoints = {
    postMarketPlace: "/marketplace/",
    getMarketPlace: "/marketplace/",
    getMyBusinesses: "/marketplace/my-businesses/",
    deleteMarketPlace: "/marketplace/",
    putMarketPlace: "/marketplace/",
}